<mat-card>
  <mat-card-header>
    <button
      class="notifications-button"
      [matMenuTriggerFor]="showNotifications() ? notifications : null"
      matIconButton
      aria-hidden="false"
      matBadge="0"
      matBadgeIcon="notifications_active"
      [hideMatBadgeIcon]="unreadNotificationsCount() <= 0"
      [matBadgeHidden]="unreadNotificationsCount() <= 0"
      (click)="loadNotifications()"
    >
      <mat-icon
        [matTooltip]="
          showNotifications()
            ? ('notifications.my-notifications' | translate)
            : ''
        "
      >
        person
      </mat-icon>
    </button>
    <mat-menu #notifications="matMenu">
      @if (loading()) {
        <div class="list-header">
          <app-loading-indicator
            [isGlobal]="false"
            size="small"
            color="primary"
          />
          {{ 'notifications.notifications' | translate }}
        </div>

        <div class="loading-skeleton">
          <ngx-skeleton-loader
            animation="progress-dark"
            [theme]="{ width: '228px', height: '41px', 'margin-bottom': '4px' }"
          />
          <ngx-skeleton-loader
            animation="progress-dark"
            [theme]="{ width: '228px', height: '41px', 'margin-bottom': '4px' }"
          />
          <ngx-skeleton-loader
            animation="progress-dark"
            [theme]="{ width: '228px', height: '41px', 'margin-bottom': '4px' }"
          />
        </div>
      } @else {
        <app-notifications />
      }
    </mat-menu>

    <div
      class="title-container-user-details"
      role="button"
      tabindex="0"
      [matTooltip]="'labels.userprofile' | translate"
      (click)="getKeycloakAccount()"
      (keydown.enter)="getKeycloakAccount()"
      (keydown.space)="getKeycloakAccount()"
    >
      <span class="login-label">{{ 'labels.signed-in-as' | translate }}</span>
      @if (user === undefined) {
        <app-loading-indicator
          [isGlobal]="false"
          size="xSmall"
          color="secondary"
        />
      } @else {
        <div>
          @if (user.title) {
            {{ user.title }}
          }
          {{ user.firstname }} {{ user.lastname }}
        </div>
      }
    </div>
  </mat-card-header>
  @if (physician) {
    <mat-card-content>
      <div>{{ 'home.my-membership-number' | translate }}</div>
      <div class="member-number">{{ physician.membership_number }}</div>
    </mat-card-content>
  }

  <button
    matIconButton
    [matTooltip]="'userCard.agb-tooltip' | translate"
    class="log-out-button"
    (click)="showAgbs()"
  >
    <mat-icon>assignment_globe</mat-icon>
  </button>

  <mat-card-footer>
    @if (isLogoutButtonEnabled()) {
      <button
        matIconButton
        [matTooltip]="'labels.logout' | translate"
        class="log-out-button"
        (click)="logout()"
      >
        <mat-icon>logout</mat-icon>
      </button>
    }
  </mat-card-footer>
</mat-card>
